import React, { useRef, useMemo } from 'react';
import JoditEditor from 'jodit-react';

const RichTextEditor = ({ value, onChange, placeholder = "Enter content here..." }) => {
  const editor = useRef(null);

  const config = useMemo(
    () => ({
      readonly: false,
      placeholder: placeholder,
      minHeight: 400,
      uploader: {
        insertImageAsBase64URI: true
      },
      buttons: [
        'bold', 'italic', 'underline', 'strikethrough', '|',
        'font', 'fontsize', '|',
        'ul', 'ol', '|',
        'align', '|',
        'link', '|',
        'paragraph', '|',
        'brush', '|',
        'undo', 'redo'
      ],
      toolbarAdaptive: false,
      controls: {
        fontsize: {
          list: '8,10,12,14,16,18,24,30,36,48,60,72,96'
        }
      }
    }),
    [placeholder]
  );

  return (
    <div className="border border-gray-300 dark:border-gray-600 rounded-lg overflow-hidden">
      <JoditEditor
        ref={editor}
        value={value}
        config={config}
        onBlur={newContent => onChange(newContent)}
        onChange={newContent => {}}
      />
    </div>
  );
};

export default RichTextEditor;
